import { render, staticRenderFns } from "./regist-detail.vue?vue&type=template&id=7fba804d&"
import script from "./regist-detail.vue?vue&type=script&lang=js&"
export * from "./regist-detail.vue?vue&type=script&lang=js&"
import style0 from "./regist-detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports